import React, { useEffect } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import CardEmpty from '../../Cards/CardEmpty';
import { RenderKilogramo, RenderCurrency } from '../../renderField/renderReadField';
import './TotalesBonificacion.css';

/**
 * Componente para mostrar los totales de bonificación
 * @param {Object} props - Props del componente
 * @param {Object} props.totalesBonificacion - Totales de bonificación
 * @param {boolean} props.useCard - Si se debe usar una tarjeta
 * @returns {JSX.Element}
 */
const TotalesBonificacion = (props) => {
    const { totalesBonificacion = {}, useCard = false } = props;
    const {
        total_bonificaciones = 0,
        total_kg = 0,
        total_bonos = 0,
        total_bonos_quetzales = 0
    } = totalesBonificacion || {};

    let spanDolares = 0;
    if (total_bonos) spanDolares = total_bonos.toFixed(4);

    const mainContent = (
        <div className='recep-bonif-totales'>
            <div className='recep-bonif-totales__column'>
                <label>Recepciones bonificadas</label>
                <span>{total_bonificaciones || 0}</span>
            </div>
            <div className='recep-bonif-totales__column'>
                <label>Kg con bonificación</label>
                <span><RenderKilogramo value={total_kg || 0} /></span>
            </div>
            <div className='recep-bonif-totales__column'>
                <label>Total de bonificación</label>
                <span title={`$ ${spanDolares}`}><RenderCurrency value={total_bonos_quetzales || 0} decimalScale={4}/></span>
            </div>
        </div>
    )

    return (
        <div className={`recep-bonif-totales__container ${useCard && 'using-card'}`}>
            {useCard ?
                <CardEmpty noShadow>
                    {mainContent}
                </CardEmpty>
                :
                mainContent
            }
        </div>
    )
};

export default TotalesBonificacion;
